import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Tag, Space, Card } from 'antd';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../../firebase/config';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const Withdrawals = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingWithdrawals();
  }, []);

  const fetchPendingWithdrawals = async () => {
    try {
      setLoading(true);
      const q = query(
        collection(db, 'withdrawalRequests'),
        where('status', '==', 'pending')
      );
      const snapshot = await getDocs(q);
      setWithdrawals(
        snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    } catch (error) {
      console.error('Error fetching withdrawals:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (withdrawalId) => {
    try {
      const processWithdrawal = httpsCallable(functions, 'processWithdrawal');
      await processWithdrawal({
        withdrawalRequestId: withdrawalId,
        status: 'approved',
      });
      fetchPendingWithdrawals();
      Modal.success({ title: 'Success', content: 'Withdrawal approved' });
    } catch (error) {
      Modal.error({ title: 'Error', content: error.message });
    }
  };

  const handleReject = async (withdrawalId) => {
    try {
      const processWithdrawal = httpsCallable(functions, 'processWithdrawal');
      await processWithdrawal({
        withdrawalRequestId: withdrawalId,
        status: 'rejected',
        adminNote: 'Rejected by admin',
      });
      fetchPendingWithdrawals();
      Modal.success({ title: 'Success', content: 'Withdrawal rejected' });
    } catch (error) {
      Modal.error({ title: 'Error', content: error.message });
    }
  };

  const columns = [
    {
      title: 'Lawyer ID',
      dataIndex: 'lawyerId',
      key: 'lawyerId',
      render: (text) => text.substring(0, 12) + '...',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => `₹${(amount / 100).toFixed(2)}`,
    },
    {
      title: 'Bank Account',
      dataIndex: 'accountHolderName',
      key: 'account',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => <Tag color={status === 'pending' ? 'orange' : 'green'}>{status}</Tag>,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <Space>
          <Button
            type="primary"
            size="small"
            icon={<CheckOutlined />}
            onClick={() => handleApprove(record.id)}
          >
            Approve
          </Button>
          <Button
            danger
            size="small"
            icon={<CloseOutlined />}
            onClick={() => handleReject(record.id)}
          >
            Reject
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h1>Withdrawal Requests</h1>
      <Card>
        <Table
          columns={columns}
          dataSource={withdrawals}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 20 }}
        />
      </Card>
    </div>
  );
};

export default Withdrawals;
